import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const ContactoPage: FC = () => {
  return (
    <>
      <PageTitle>Contacto</PageTitle>
      <View />
    </>
  );
};

export { ContactoPage };
